{
  "Language": {
    "Name": "English",
    "Locality": "United States"
  },
  "Breadcrumb": {
    "Home": "Home",
    "UserLookup": "User Lookup",
    "UserRoles": "User Roles",
    "LocationManager": "Location Manager",
    "EditLocation": "Edit Location",
    "AddNewUser": "Add New User",
    "EditUserRole": "Edit User Role",
    "AddNewRequest": "Add New Request",
    "RequestDetails": "Request Details",
    "EditRoles": "Edit Roles",
    "LocationUserManagement": "Location and User Management",
    "UserAccessHistory": "User Access History",
    "AddNewUsers": "Add New Users",
    "NotificationSettings": "Notification Settings"
  },
  "Term": {
    "TrailerReservationSystem": "Trailer Reservation System",
    "TrailerReservationSuite": "Trailer Reservation Suite",
    "NetworkCarrierManagement": "Network Carrier Management",
    "Sort": "Sort",
    "Planned": "Planned",
    "AdHoc": "Ad Hoc",
    "Next": "Next",
    "Cancel": "Cancel",
    "Edit": "Edit",
    "Delete": "Delete",
    "New": "New",
    "Submit": "Submit",
    "Enabled": "Enabled",
    "Disabled": "Disabled",
    "Continue": "Continue",
    "Confirm": "Confirm",
    "UpsId": "UPS.com ID",
    "Phone": "Phone",
    "By": "By",
    "Email": "Email",
    "Role": "Role",
    "Yes": "Yes",
    "No": "No",
    "Location": "Location",
    "Locations": "Locations",
    "User": "User",
    "Users": "Users",
    "Date": "Date",
    "Reason": "Reason",
    "AreYouSure": "Are you sure?",
    "RequiredFieldNotice": "Indicates required field",
    "Selected": "Selected",
    "Or": "or",
    "To": "to",
    "Displaying": "Displaying",
    "BasedOnSearchResults": "based on search results",
    "BasedOnSearchResultsLocationUsers": "based on search results.",
    "Loading": "Loading...",
    "Custom": "Custom",
    "CountryCode": "Country Code",
    "LocationCode": "Location Code",
    "LocationSlic": "Location SLIC",
    "UserId": "User ID",
    "On": "On",
    "Off": "Off",
    "OfSingle": "of",
    "OfMultiple": "of"
  },
  "Role": {
    "Administrator": "Administrator",
    "ViewEdit": "View & Edit",
    "ViewOnly": "View Only",
    "NoAccess": "No Access"
  },
  "ServiceLevel": {
    "Ground": "Ground",
    "Air": "Air",
    "NextDayAir": "Next Day Air",
    "SecondDayAir": "Second Day Air",
    "ThreeDaySelect": "Three Day Select",
    "EarlyAM": "Early AM"
  },
  "TrailerType": {
    "Short": "Short",
    "Long": "Long",
    "Air": "Air"
  },
  "TrailerSize": {
    "Short": "Short",
    "Long": "Long",
    "Air": "Air"
  },
  "Sort": {
    "Sunrise": "Sunrise",
    "Preload": "Preload",
    "Morning": "Morning",
    "Day": "Day",
    "Afternoon": "Afternoon",
    "Local": "Local",
    "Twilight": "Twilight",
    "Night": "Night",
    "TotalUsers": "Total Users"
  },
  "RequestType": {
    "Delivery": "Delivery",
    "LiveLoad": "Live Load",
    "Switch": "Switch",
    "RetrieveEmpty": "Retrieve Empty",
    "RequestEmpty": "Request Empty",
    "RetrieveLoad": "Retrieve Load",
    "Other": "Other",
    "REALIGN": "Realign"
  },
  "RequestCategory": {
    "Planned": "Planned",
    "AdHoc": "Ad Hoc"
  },
  "Legal": {
    "TermsNotice1": "By submitting this trailer request, I agree to the terms of the",
    "TermsNotice2": "UPS Tariff/Terms and Conditions of Service",
    "TermsNotice3": "and the",
    "TermsNotice4": "UPS Technology Agreement",
    "TermsNotice5": "(\"UPS Terms\") and understand that such UPS Terms apply to my trailer request.",
    "Copyright": "Copyright",
    "CopyrightDisclaimer": "United Parcel Service of America, Inc. All rights reserved.",
    "TermsAndConditionsUrl": "https://www.ups.com/assets/resources/media/en_US/terms_service_us.pdf",
    "TechnologyAgreementUrl": "https://www.ups.com/assets/resources/media/en_US/UTA.pdf",
    "PrivacyPolicyUrl": "https://www.ups.com/us/en/help-center/legal-terms-conditions/privacy-notice.page",
    "TermsOfServiceUrl": "https://www.ups.com/us/en/help-center/legal-terms-conditions/website.page"
  },
  "ModalText": {
    "DeleteNewRole": "If you continue, this user will not be added to this location and will not be able to view or edit.",
    "CancelAddUsersSingle": "If you continue, this user will not be added to this location and will not be able to view or edit.",
    "CancelAddUsersMultiple1": "If you continue, these",
    "CancelAddUsersMultiple2": "will not be added to this location and will not be able to view or edit.",
    "DenyUserRequest": "If you continue, this request will be permanently denied.",
    "DeleteEditRole": "If you continue, this user will not be able to view or edit this location.",
    "RemoveUser": "If you continue, this user will no longer have access to this location.",
    "DeleteFromLocation": "If you continue, this user will no longer have access to any of these locations.",
    "DeleteUsersFromLocation": "If you continue, these users will no longer have access to this location."
  },
  "DatePicker": {
    "StartDate": "Start Date",
    "EndDate": "End Date",
    "Today": "Today",
    "Clear": "Clear",
    "Close": "Close",
    "DateFormatting": "MM/DD/YYYY",
    "PriorComments": "unread comments on prior dates",
    "FutureComments": "unread comments on future dates"
  },
  "HomePage": {
    "Header": "Reservation Dashboard",
    "LocationManager": "Location Manager",
    "LocationUserManager": "Location & User Management",
    "UserLookup": "User Lookup",
    "AddRequest": "Add New Request",
    "RequestType": "Request Type",
    "TrailerType": "Trailer Type",
    "TrailerSize": "Trailer Size",
    "Destination": "Destination",
    "DestinationSort": "Destination Sort",
    "ServiceLevel": "Service Level",
    "EarliestDueDate": "Earliest Due Date",
    "LatestDueDate": "Latest Due Date",
    "Apply": "Apply",
    "ClearFilters": "Clear Filters",
    "Status": "Status",
    "Type": "Type",
    "EarliestTime": "Earliest Time",
    "LatestTime": "Latest Time",
    "UPSLocationCode": "UPS Location Code",
    "LocationName": "Location Name",
    "SearchRequests": "Search Requests",
    "SortBy": "Sort By",
    "FSNoticeTitle": "Attention!",
    "FSNoticeText": "The date range you have selected may contain planned requests that are not shown on this page. Planned requests that occur after this coming Saturday may not be visible.",
    "UnreadComments": "Unread Comments",
    "LocationCode": "Location Code",
    "CustomLocationName": "Custom Location Name",
    "TotalRequests": "Total Requests",
    "StateProvinceTerritory": "State/Province/Territory",
    "PendingRequests": "Pending Requests",
    "InProgressRequests": "In Progress Requests",
    "CompletedRequests": "Completed Requests",
    "ExportRequests": "Export Requests",
    "TrailerRequestsExportFilename": "ReservationDashboard_Requests",
    "NoResultsMatched": "No results matched your current criteria.",
    "TrailerDirection": "Trailer Direction",
    "TrailerVolume": "Trailer Volume",
    "Volume": "Volume",
    "NoVolume": "No Volume",
    "Pallets": "Pallets",
    "Gaylords": "Gaylords",
    "FromUPS": "From UPS",
    "ToUPS": "To UPS",
    "PlanNotMet": "Plan Not Met",
    "NotPlanned": "Not Planned",
    "TractorOnly": "Tractor Only",
    "NotificationSettings": "Notification Settings",
    "CreatedAs": "Created As",
    "Requests": "Requests",
    "OnProperty": "On Property",
    "DestinationDoesNotExist": "Destination does not exist"
  },
  "FilterChip": {
    "TotalRequests": "Total Requests",
    "NotFulfilled": "Not Fulfilled",
    "Pending": "Pending",
    "Approved": "Approved",
    "Scheduled": "Scheduled",
    "InTransit": "In Transit",
    "OnProperty": "On Property",
    "Completed": "Completed",
    "Canceled": "Canceled",
    "Canceling": "Canceling",
    "Attention": "Attention",
    "Needed": "Needed"
  },
  "TrailerCard": {
    "No": "No.",
    "ArriveTime": "Arrive Time",
    "Arriving": "Planned Arrival",
    "Arrived": "Arrived",
    "PullTime": "Pull Time",
    "Earliest": "Earliest",
    "Latest": "Latest",
    "Job": "Job",
    "Tractor": "Tractor",
    "FromUPS": "From UPS",
    "ToUPS": "To UPS",
    "Bay": "Bay",
    "Pallets": "Pallets",
    "Approved": "Approved",
    "Scheduled": "Scheduled",
    "InTransit": "In Transit",
    "OnProperty": "On Property",
    "Complete": "Complete",
    "Details": "Details",
    "Contact": "Contact",
    "Due": "Due",
    "Comments": "Comments",
    "NotPlanned": "Not Planned",
    "DriverCreatedRequest": "Driver Created Request",
    "TractorOnly": "Tractor Only"
  },
  "LocationList": {
    "SearchLocations": "Search Locations",
    "AllLocations": "All Locations",
    "Pending": "Pending",
    "InProgress": "In Progress",
    "Completed": "Completed",
    "LoadMore1": "Load Next",
    "LoadMore2": "Locations",
    "CustomNameHyperlink": "Assign Custom Name",
    "PendingRemoval": "Pending Removal",
    "OpenOnPropertyView": "Open On-Property View"
  },
  "AddRequestPage": {
    "Header": "Add New Request",
    "Description": "Use the fields below to tell us about your request.",
    "CustomerLocation": "Customer Location",
    "RequestType": "Request Type",
    "ValidLocation": "Please select a valid location"
  },
  "RequestFormPage": {
    "Description": "Use the fields below to tell us about your request.",
    "RequestWindow": "Request Window",
    "EarliestDate": "Earliest Date",
    "EarliestTime": "Earliest Time",
    "LatestDate": "Latest Date",
    "LatestTime": "Latest Time",
    "LoadedTrailer": "Loaded Trailer",
    "DestinationFacility": "Destination UPS Facility",
    "DestinationSort": "Destination Sort",
    "TrailerType": "Trailer Type/Size",
    "TrailerNumber": "Trailer Number",
    "ServiceLevel": "Service Level",
    "FillOneOfThree": "You must fill out at least one of the next three fields regarding load contents.",
    "FillOneOfTwo": "You must fill out at least one of the next two fields regarding load contents.",
    "OptionalLoadFields": "The following three fields regarding load contents are optional.",
    "Pieces": "Number of Pieces",
    "Pallets": "Number of Pallets",
    "Fullness": "Percent Full",
    "Gaylords": "Number of Gaylords",
    "Bags": "Number of Bags",
    "Irregs": "Number of Irregular Pieces",
    "Quantity": "Quantity",
    "EmptyTrailer": "Empty Trailer",
    "Bay": "Bay/Door",
    "AdditionalInformation": "Additional Information",
    "RequestReason": "Why are you requesting an additional movement?",
    "DeliveryNumber": "Delivery Number",
    "PickupNumber": "Pickup Number",
    "SpecialInstructions": "Special Instructions",
    "IfYouContinue": "If you continue",
    "ThisRequestWillNotBeCreated": "this request will not be created",
    "ThisRequestWillNotBeSaved": "this request will not be saved",
    "YourEditsWillNotBeSaved": "your edits will not be saved",
    "MustBeInTheFuture": "Please select a future date",
    "MustBeWithin90DaysFromToday": "Date must be within 90 days",
    "MustBeBeforeLatestPickup": "Must be before latest pickup",
    "MustBeAfterEarliestPickup": "Must be after earliest pickup",
    "ThisFieldIsRequired": "This field is required",
    "MustBeValidPercent": "Must be a valid percentage",
    "MustBeGreaterThanZero": "Must be greater than zero",
    "Edit": "Edit",
    "New": "New",
    "WeekendNotificationTitle": "Warning!",
    "WeekendNotificationMessage": "You are about to submit a request during the weekend. Some UPS facilities are not open on weekends. You may not receive a response until Monday.",
    "PeakSeasonDateRangeWarning": "This request falls during UPS peak season and will be reviewed on ",
    "InvalidTime": "Time is not in the valid range.",
    "InvalidDate": "Date is not in the valid range.",
    "InvalidFieldNotification": "Some field entries are invalid. Please correct each field and submit again.",
    "ServerFailureNotification": "Could not submit request. Please try again. If the problem persists, contact the dispatch office at the selected UPS Destination Facility.",
    "LocationSetupIncompleteMessage": "isn't currently setup to add new requests in TRS. Please contact your local dispatch.",
    "LocationSetupIncomplete": "Location Setup Incomplete",
    "DestinationSetupIncompleteMessage": "The destination/sort that you've selected isn't set up to add new requests. Please change the destination/sort or contact your local dispatch.",
    "DefaultResponsibleLocation" : "Responsible UPS Location"
  },
  "Header": {
    "ProfileOverview": "Profile Overview",
    "MyInformation": "My Information",
    "Addresses": "Addresses",
    "AccountsPayment": "Accounts and Payment",
    "Preferences": "Preferences",
    "ViewPayBill": "View & Pay Bill",
    "LogOut": "Log Out",
    "SignUp": "Sign Up"
  },
  "Footer": {
    "PrivacyPolicy": "Privacy Policy",
    "TermsConditions": "Terms and Conditions",
    "Legal": "Legal"
  },
  "CancelModal": {
    "Description": "If you continue, this request will be permanently canceled.",
    "RequestType": "Request Type",
    "PleaseEnterAReason": "Please enter a reason that this request will be canceled.",
    "Holiday": "Holiday",
    "Weather": "Weather",
    "Volume did not generate": "Volume did not generate",
    "Duplicate request": "Duplicate Request",
    "Other": "Other",
    "OtherPleaseSpecify": "Other (Please Specify)",
    "OtherReason": "Other Reason",
    "Scheduling error": "Scheduling Error",
    "Covered by Package Center": "Covered by Package Center",
    "FailedToSaveChanges": "Failed to save your changes. Please try again."
  },
  "RequestDetailsPage": {
    "Header": "Request Details",
    "GeneralInformation": "General Information",
    "RequestId": "Request ID",
    "RequestInstructions": "Request Instructions",
    "UserId": "User ID",
    "Created": "Created",
    "Date": "Date",
    "Edited": "Edited",
    "Approved": "Approved",
    "Canceled": "Canceled",
    "Canceling": "Canceling",
    "Rejected": "Not Fulfilled",
    "Bags": "Bags",
    "BayNumber": "Bay Number",
    "DeliveryNumber": "Delivery Number",
    "Destination": "Destination",
    "DestinationSort": "Destination Sort",
    "DueDate": "Due Date",
    "Earliest": "Earliest",
    "Gaylords": "Gaylords",
    "Irregs": "Irregulars",
    "Latest": "Latest",
    "NotFulfilledReason": "Not Fulfilled Reason",
    "Pallets": "Pallets",
    "PercentFull": "Percent Full",
    "Pieces": "Pieces",
    "PickupNumber": "Pickup Number",
    "Reason": "Reason",
    "RequestStatus": "Request Status",
    "RequestType": "Request Type",
    "ServiceLevel": "Service Level",
    "SpecialInstructions": "Special Instructions",
    "TrailerNumber": "Trailer Number",
    "TrailerType": "Trailer Type",
    "TrailerSize": "Trailer Size",
    "Pending": "Pending",
    "CustomerSelected": "Customer Selected",
    "TransferRequested": "Transfer Requested",
    "TransferApproved": "Transfer Approved",
    "TransferRejected": "Transfer Rejected",
    "InTransit": "In Transit",
    "OnProperty": "On Property",
    "PickedUp": "Picked Up",
    "Completed": "Completed",
    "Scheduled": "Scheduled",
    "Transferred": "Transferred",
    "UndoTransfer": "Undo Transfer"
  },
  "LocationManagerPage": {
    "Header": "Location Manager",
    "LocationCode": "Location Code",
    "CustomLocationName": "Custom Location Name",
    "PickupAddress": "Pickup Address",
    "Users": "Users",
    "Actions": "Actions",
    "EditLocation": "Edit Name/Users"
  },
  "LocationUserPage": {
    "RemoveUser": "Remove User",
    "Users": "Users",
    "Edit": "Edit",
    "SearchUsers": "Search Users",
    "ServerFailureNotification": "An error occurred while processing this request. Please try again.",
    "NoLocationsMatch": "No results match your search criteria.",
    "NewUserRequests": "New User Requests",
    "AllUsers": "All Users",
    "NoUserRequestsToReviewPart1": "Currently there are no New User Requests to review. A numbered orange indicator",
    "NoUserRequestsToReviewPart2": "will appear in event of a new request(s).",
    "LastUpdated": "Last Updated",
    "By": "by",
    "SortLocationsBy": "Sort Locations By",
    "Export": "Export",
    "LocationUserExportFilename": "LocationsAndUsers",
    "SortUsersBy": "Sort Users By",
    "UserId": "User ID",
    "Email": "Email",
    "NumberOfLocations": "Number of Locations"
  },
  "LocationPage": {
    "Header": "Edit Location",
    "CustomLocationName": "Custom Location Name",
    "AddUsers": "Add New Users",
    "LastUpdated": "Last Updated",
    "Actions": "Actions",
    "EditRole": "Edit Role",
    "Users": "Users",
    "NewUserRequests": "New User Requests",
    "Approve": "Approve",
    "Deny": "Deny",
    "ChangesSaved": "Changes Saved",
    "CustomNameRequired": "Custom name is required",
    "RemoveSelectedUsers": "Remove Selected Users"
  },
  "LocationManagerEditRolePage": {
    "Header": "Edit User Role",
    "RemoveUser": "Remove User"
  },
  "NoLocationPage": {
    "Header": "Reservation Dashboard",
    "NoticeTitle": "Attention!",
    "NoticeText": "You do not yet have any locations in your profile. Contact your administrator or a UPS dispatch center to request access."
  },
  "UserRolesPage": {
    "Header": "User Roles",
    "AddNewRoles": "Add New Roles/Locations",
    "LocationCode": "Location Code",
    "CustomLocationName": "Custom Location Name",
    "LastUpdated": "Last Updated",
    "Actions": "Actions",
    "Remove": "Remove",
    "EditRole": "Edit Role",
    "RemoveFromListedLocations": "Remove from Listed Locations"
  },
  "AddUserPage": {
    "Header": "Add New Users",
    "User": "User",
    "AddAnother": "Add Another User",
    "UserExistsAtLocation": "User exists at this location",
    "DuplicateId": "Duplicate UPS.com ID",
    "EmailInvalid": "Email is invalid",
    "RoleInvalid": "Role is invalid",
    "ThisFieldIsRequired": "This field is required",
    "UpsIdExistsAtLocation": "UPS.com ID already exists at this location",
    "UserQueueCancelMessage": "If you continue, the users you have added to the queue will not be added to the Trailer Reservation System.",
    "NewUserQueue": "New User Queue",
    "EntriesListed": "entries listed",
    "AddNewUsers": "Add New Users",
    "SearchAndAddLocations": "Search & Add Locations",
    "AddToQueue": "Add to Queue",
    "ServerFailureNotification": "An error occurred while processing this request. Please try again.",
    "DeleteUser": "Delete User",
    "DownloadTemplate": "Download Template",
    "LocationUserImportTemplateFilename": "Import Template",
    "ImportUsers": "Import Users",
    "EntriesNeedAttention": "entries need attention",
    "EntryNeedsAttention": "entry needs attention",
    "InvalidUPSId": "Please enter a valid UPS.com ID"
  },
  "AddNewRolesPage": {
    "Header": "Add New Roles",
    "AddAnotherLocation": "Add Another Location",
    "LocationIsRequired": "Location is required",
    "RoleIsRequired": "Role is required"
  },
  "EditUserPage": {
    "Header": "Edit User Role",
    "RemoveUser": "Remove User"
  },
  "EditRolesPage": {
    "Header": "Edit Roles"
  },
  "UserLookupPage": {
    "Header": "User Lookup",
    "Description": "You must fill out at least one of the next two fields.",
    "NoInputError": "Please fill out one",
    "NoResultsError": "No results found"
  },
  "ContactModal": {
    "Header": "Contact Information",
    "ResponsibleUpsLocation": "Responsible UPS Location",
    "Phone": "Phone",
    "Email": "Email",
    "Continue": "Continue",
    "Sunday": "Sunday",
    "Monday": "Monday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday",
    "Thursday": "Thursday",
    "Friday": "Friday",
    "Saturday": "Saturday",
    "HoursOfOperation": "Hours of Operation",
    "NoAvailableInformation": "No Available Information",
    "Open24Hours": "Open 24 Hours",
    "Closed": "Closed"
  },
  "CommentsModal": {
    "AddComment": "Add Comment",
    "PreviousComments": "Previous Comments",
    "CommentRefresh": "Comment Refresh",
    "FailedToSubmit": "Failed to submit your message. Please try again."
  },
  "CustomNameModal": {
    "CustomLocationName": "Custom Location Name",
    "CustomNameWarning": "This change will be applied for all users",
    "EditLocationName": "Edit Location Name",
    "NewLocationName": "New Location Name",
    "CurrentLocationName": "Current Location Name",
    "LastUpdated": "Last Updated",
    "SaveFailed": "Failed to save your changes. Please try again"
  },
  "RemoveUserModal": {
    "RemoveUser": "If you continue, this user will no longer have access to any of these locations.",
    "SaveFailed": "Failed to save your changes. Please try again"
  },
  "TimeZones": {
    "EST": "EST",
    "EDT": "EDT",
    "CST": "CST",
    "CDT": "CDT",
    "MST": "MST",
    "MDT": "MDT",
    "PST": "PST",
    "PDT": "PDT",
    "AST": "AST",
    "ADT": "ADT"
  },
  "RequestRejection": {
    "SelectResponse": "Select a Response",
    "CancelResponse": "Cancel the Request",
    "FulfillRequestOn": "Fulfill request on ",
    "AndProcessOn": " and process on ",
    "EarliestTimeAfterCriticalPullTime": "Earliest available time is after the critical pull time",
    "NetworkOverCapacity": "Network is over capacity",
    "SubmittedAfterCutoffTime": "Submitted after the request cutoff time",
    "VolumeDoesNotJustifyPickup": "Volume does not justify for trailer pickup",
    "VolumeOverAllocation": "Volume over allocation",
    "Weather": "Weather",
    "RequestMovedTo": "This request will be moved to ",
    "RequestMovedToCanceledStatus": "This request will be moved to Canceled status",
    "PeakVolumeOverAllocation": "Peak Volume Over Allocation",
    "UPSHoliday": "UPS Holiday",
    "CustomerHasSufficientEquipment": "Customer has Sufficient Equipment",
    "NoEquipmentAvailable": "No Equipment Available",
    "NoResponseFromCustomer": "No response from customer",
    "NotFulfilled": "Not Fulfilled"
  },
  "Months": {
    "January": "January",
    "February": "February",
    "March": "March",
    "April": "April",
    "May": "May",
    "June": "June",
    "July": "July",
    "August": "August",
    "September": "September",
    "October": "October",
    "November": "November",
    "December": "December"
  },
  "SystemMessage": {
    "OneOfOne": "1 of 1",
    "DownForMaintenance": "Trailer Reservation System is currently down for maintenance."
  },
  "UserAccessHistory": {
    "UserInformation": "User Information",
    "Date": "Date",
    "Time": "Time",
    "Location": "Location",
    "Role": "Role",
    "Activity": "Activity",
    "UserId": "User ID",
    "Entry": "entry",
    "Entries": "entries",
    "SearchChangeHistory": "Search Change History"
  },
  "UserAccessActivity": {
    "Submitted": "Submitted",
    "Added": "Added",
    "Removed": "Removed",
    "Approved": "Approved",
    "Denied": "Denied",
    "Updated": "Updated"
  },
  "Toast": {
    "FailedToSaveChanges": "Failed to save your changes. Please try again.",
    "UserDataIsStale": "Another user has edited this information since you opened the page. Click here to refresh or allow 30 seconds for the data to refresh.",
    "StorageAccountIsDown": "We're having an issue sending requests to Dispatch. If you need to contact Dispatch before this issue is resolved, click the blue  \"Contact\" link in the upper right of the request. When the connection is restored, this banner will disappear.",
    "FailedToExport": "Failed to export. Please try again.",
    "FailedToRetrieveOnPropertyData": "Failed to load on-property data. Please refresh the page."
  },
  "ImportUsersErrorModal": {
    "ImportErrorHeader": "Could not import",
    "ImportErrorBody": "Please check to make sure that you are importing the Excel template provided and that all of the columns are filled out."
  },
  "InvalidImportEntriesModal": {
    "InvalidImportEntriesHeader": "We were unable to import some users.",
    "InvalidImportEntriesDueTo": "Due to errors in the Excel document ",
    "InvalidImportEntriesUsersWereNotImported": " users were not imported due to an error in Country Code, Location SLIC and/or User ID. Please make the necessary corrections in the Excel file before trying to import them again.",
    "InvalidImportEntriesNote": "NOTE: Importing the entire Excel file again will not result in duplicate entries. Only new and fixed entries will be added to the New User Queue.",
    "InvalidImportEntriesTheseWere": "These were the ",
    "InvalidImportEntriesErrorsFound": " errors found in the Excel File:"
  },
  "ExportModal": {
    "ExportCommentsHeader": "Include comments in export?",
    "ExportCommentsBodyText": "Including comments in the export can result in extra rows of repeating information.",
    "ExportCommentsBodyExplanation": "For example, if a request contains (3) comments, that request will show up (3) separate times with all information being indentical except for the comment.",
    "ExportCommentsCheckLabel": "Yes, include comments in this export",
    "Export": "Export",
    "FailedToExport": "Failed to export. Please try again."
  },
  "NotificationSettings": {
    "NotificationSettings": "Notification Settings",
    "DeliveryType": "Delivery Type",
    "EmailNotifications": "Email Notifications",
    "AddEmailAddress": "Add Email Address",
    "AttentionNeeded": "Attention Needed",
    "Pending": "Pending",
    "Approved": "Approved",
    "Scheduled": "Scheduled",
    "InTransit": "In Transit",
    "OnProperty": "On Property",
    "Completed": "Completed",
    "Canceled": "Canceled",
    "StatusChange": "Status Change",
    "AllToggles": "All Toggles",
    "Comment": "Comment",
    "RequestEdited": "Request Edited",
    "UserRequest": "User Request",
    "NotificationsToReceive": "Notifications to Receive",
    "SortByLocation": "Sort By Location",
    "StatusChangeOn": "Status Change On",
    "CommentOn": "Comment On",
    "RequestEditedOn": "Request Edited On",
    "AdminLocations": "Admin Locations",
    "NoResultsMatched": "No results match your search criteria.",
    "Displaying": "Displaying",
    "SortInstructions": "Select a location to change its settings. You can select multiple locations to manage at once.",
    "AddAnotherEmail": "Add Another Email",
    "WeeklyPlannedRequest": "Weekly Planned Request",
    "WeeklyPlannedRequestInfo": "Enable to receive an email for each\nplanned request during the weekly\nupload. For example, 1,500 planned\nrequests will generate 1,500 emails."
  },
  "DeliveryTypeModal": {
    "DeliveryTypeHeader": "Edit Contact Info",
    "DeliveryTypeSubText": "Update your preferred contact information",
    "EmailInvalid": "Email is invalid",
    "PhoneInvalid": "Phone number is invalid",
    "SaveFailed": "Failed to apply. Please try again."
  },
  "OnProperty": {
    "OnPropertyView": "On Property View",
    "SearchYourLocations": "Search your locations",
    "NoResultsMatched": "No results match your search criteria.",
    "Showing": "Showing",
    "Trailers": "trailer(s)",
    "DayOP": "Day OP",
    "DaysOP": "Days OP",
    "Of": "of",
    "SearchAllTrailers" : "Search All Trailers",
    "NoDataForLocation": "On-property data not available for this location.",
    "ExportTrailerList": "Export Trailer List",
    "TrailerListExportSuccess": "Trailer list successfully exported.",
    "TrailerListExportFailure": "Failed to export. Please try again.",
    "TrailerListExportFileName": "TRS_Trailer_Export_",
    "Available": "Available",
    "Empty": "Empty",
    "PullTime": "Pull Time",
    "TrailerState": "Trailer State"
  },
  "StatusValues": {
    "Pending": "Pending",
    "Approved": "Approved",
    "Scheduled": "Scheduled",
    "InTransit": "In Transit",
    "OnProperty": "On Property",
    "Completed": "Completed",
    "Canceled": "Canceled",
    "Canceling": "Canceling",
    "NotFulfilled": "Not Fulfilled"
  }
}
